import React from 'react';
import ReactDOM from 'react-dom';
import Top from "./Top"
import Chat from "./Chat"
import App from './App';
import { BrowserRouter as Router, Route } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

import 'bootstrap/dist/css/bootstrap.min.css';

Amplify.configure(awsconfig)

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Route exact path="/" component={Top} />
      <Route exact path="/live" component={App} />
      <Route exact path="/chat" component={Chat} />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
